import * as React from "react";

export class SortedHeading extends React.Component<{
    text: string
}, {}> {

    render() {
        return (
            <div className="rj-my-pulse-bets__sorted-heading-message">
                <span className="rj-my-pulse-bets__sorted-heading-message-text">{this.props.text}</span>
            </div>
        )
    }
}